// 了解索道云
import request from '@/utils/request'

//主页
export function queryCustomerListOverOne(pageSize, startNum) {
    return request.post('/front/content/queryCustomerListOverOne?pageSize=' + pageSize + '&startNum=' + startNum)
}

export function queryNewsListOverOne(pageSize, startNum) {
    return request.post('/front/content/queryNewsListOverOne?pageSize=' + pageSize + '&startNum=' + startNum)
}

//新闻动态
export function queryNewsList(param) {
    return request.post('/front/content/queryNewsList', param)
}